import React from 'react';
import { KEYBOARD_KEYS } from '../utils/accessibility';
import './ThinkingSection.css';

interface ThinkingSectionProps {
  content: string;
  isExpanded?: boolean;
  onToggle: () => void;
  messageId?: string;
}

const ThinkingSection: React.FC<ThinkingSectionProps> = ({
  content,
  isExpanded = false,
  onToggle,
  messageId = 'default'
}) => {
  const thinkingId = `thinking-content-${messageId}`;
  const toggleId = `thinking-toggle-${messageId}`;

  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === KEYBOARD_KEYS.ENTER || e.key === KEYBOARD_KEYS.SPACE) {
      e.preventDefault();
      onToggle();
    }
  };

  return (
    <div className="thinking-section" role="group" aria-labelledby={toggleId}>
      <button
        id={toggleId}
        className="thinking-toggle accessible-button"
        onClick={onToggle}
        onKeyDown={handleKeyDown}
        aria-expanded={isExpanded}
        aria-controls={thinkingId}
        aria-label={`${isExpanded ? 'Collapse' : 'Expand'} AI thinking process`}
        type="button"
      >
        <span className="thinking-icon" aria-hidden="true">
          {isExpanded ? '▼' : '▶'}
        </span>
        <span className="thinking-label">Thinking</span>
        <span className="sr-only">
          {isExpanded ? '(expanded)' : '(collapsed)'}
        </span>
      </button>
      
      {isExpanded && (
        <div
          id={thinkingId}
          className="thinking-content"
          role="region"
          aria-label="AI thinking process content"
          aria-live="polite"
        >
          <div className="thinking-text" role="text">
            {content}
          </div>
        </div>
      )}
    </div>
  );
};

export default ThinkingSection;